import Checkbox from "component/checkbox/checkbox"


interface SurchargeModelsProps {
    enablePeakDateSurcharges: boolean
    peakSurchargesVaryByRoomType: boolean
    enablePerPersonSeasonalSurcharges: boolean
    onEnablePeakDateSurchargesChange: (value: boolean) => void
    onPeakSurchargesVaryByRoomTypeChange: (value: boolean) => void
    onEnablePerPersonSeasonalSurchargesChange: (value: boolean) => void
    perPersonSeasonalSurchargeError?: string
}

const SurchargeModels = ({
    enablePeakDateSurcharges,
    peakSurchargesVaryByRoomType,
    enablePerPersonSeasonalSurcharges,
    onEnablePeakDateSurchargesChange,
    onPeakSurchargesVaryByRoomTypeChange,
    onEnablePerPersonSeasonalSurchargesChange,
    perPersonSeasonalSurchargeError,
}: SurchargeModelsProps) => {

    const handleEnablePeakDateSurchargesChange = (value: boolean) => {
        if(value === false){
            onPeakSurchargesVaryByRoomTypeChange(false);
        }
        onEnablePeakDateSurchargesChange(value);
    }

    return (
        <>
            <b>Surcharge Models</b>
            <div className="surcharge-models-section">
                <div className="surcharge-model-item">
                    <Checkbox
                        label="Enable Peak Date Surcharges"
                        checked={enablePeakDateSurcharges}
                        onChange={handleEnablePeakDateSurchargesChange}
                    />
                    {enablePeakDateSurcharges && (
                        <div className="nested-checkbox">
                            <Checkbox
                                label="Peak surcharges Vary By Room Type"
                                checked={peakSurchargesVaryByRoomType}
                                onChange={onPeakSurchargesVaryByRoomTypeChange}
                            />
                        </div>
                    )}
                </div>
                <div className="surcharge-model-item">
                    <Checkbox
                        label="Enable Per-Person Seasonal Surcharges"
                        checked={enablePerPersonSeasonalSurcharges}
                        onChange={onEnablePerPersonSeasonalSurchargesChange}
                    />
                    {perPersonSeasonalSurchargeError && (
                        <div className="error-message" style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px" }}>
                            {perPersonSeasonalSurchargeError}
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default SurchargeModels
